import Yup from '_zari/validation/_yup'

export default Yup.object().shape({
  _idProyecto: Yup.string().required(),
  moneda: Yup.string().required(),
  anoDesde: Yup.number().required()
})
